module.exports = __webpack_public_path__ + "static/media/trash.08bc8dec.svg";